import {loadQuestions} from "../actions/knowledge-questions";
import {takeEvery, select, put, call} from "redux-saga/effects";

const getProject = (state) => state.project;

export function* questionsWatcher() {
    yield takeEvery('*', function* checkQuestions(action) {
        const state = yield select();

        let instance = state.gameInstance.instance;
        let questions = state.knowledgeQuestions;

        if (instance && questions.list === null && !questions.loading && instance['properties']['PROFILE_COMPLETE']) {
            yield put(loadQuestions(state.gameInstance.instance.id));
        }
    })
}
